import React, { useCallback } from 'react';
import { Modal, Button } from 'antd';
import '../CodingChallengeWarning/coding-challenge-warning.scss';
import { ClockIcon } from '../../../legacy_components/components/common/CustomIcon';
import { PlayCircleOutlineRounded } from '@material-ui/icons';
import { changePreviousDevData } from '../util';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faExclamationTriangle,
  faFileDownload,
} from '@fortawesome/free-solid-svg-icons';
import LaptopIcon from '../../../assets/img/laptop-icon.svg';
import VideoCameraIcon from '../../../assets/img/video-camera.svg';
import ReportIcon from '../../../assets/img/report.svg';
import RecordScreenIcon from '../../../assets/img/record-screen.svg';
import CompassIcon from '../../../assets/img/compass.svg';

const APTWarning = ({
  home,
  onStart,
  onCancel,
  challengeDuration,
  inProgress,
  timeLeft,
  challengeId,
  show_apt_plagiarism_warning,
  gb_apt_instructions_config,
  show_apt_requirements_warning,
}) => {
  const instructionsConfig =
    gb_apt_instructions_config && gb_apt_instructions_config[challengeId];

  const openFile = useCallback((url) => {
    window.open(url, '_blank');
  }, []);

  const modalWidth = '721px';

  return (
    <Modal visible={true} footer={null} width={modalWidth} onCancel={onCancel}>
      <div className="codingChallengeWarning">
        <div className="title">
          <div className="text">Start Practical Challenge Now?</div>
        </div>

        <p className="description">
          You have {inProgress ? timeLeft : challengeDuration} minutes to
          complete the Challenge. The Challenge is designed to be hard to
          complete within {challengeDuration} min, but don’t worry – you will
          get credits for each subtask you complete. The time will start running
          after you proceed.
        </p>
        {instructionsConfig && (
          <p
            className="instructions-box"
            onClick={() => openFile(instructionsConfig.url)}
          >
            <div className="download-icon">
              <FontAwesomeIcon icon={faFileDownload} />
            </div>
            <div>
              If this is your first time taking a{' '}
              {instructionsConfig.challengeType}, please{' '}
              <span className="highlight">click here to review</span> the
              specific instructions for this challenge.
            </div>
          </p>
        )}
        {show_apt_requirements_warning && (
          <p className="instructions-box">
            <div>
              Practical challenges can only be initialized if permissions to
              access the screen for recording are granted during the tests to
              record the entire screen on which the test is being conducted.
              Also, ensure your internet speed is at least 4Mbps download and
              2Mbps upload, and you are running Chrome (or Chromium based) 74+,
              Firefox 78+, Opera 64+, Safari 12+, Edge 79+
            </div>
          </p>
        )}
          <div style={{ marginTop: 24 }}>
            <h4 className="title">Fair assessment policy:</h4>

            <p>
              For your test attempt to be considered valid, <b>you accept
              that during this session:</b>{' '}
            </p>

            <div>
              <div className="useAccVideoRecording listItem">
                <img
                  src={LaptopIcon}
                  className="listItemImg"
                  style={{ marginRight: 16 }}
                />
                <div className="text">Your entire screen will be recorded, not just a specific tab or window.</div>
              </div>

              <div className="useAccVideoRecording listItem">
                <img
                  src={VideoCameraIcon}
                  className="listItemImg"
                  style={{ marginRight: 16 }}
                />
                <div className="text">
                  Your video and audio will be recorded. You will need a working
                  webcam/camera and microphone, in a well-lit environment with
                  clear view of your face and clear audio without background
                  noise. Absence of clear video and audio will result in an invalid test attempt.
                </div>
              </div>

              <div className="useAccVideoRecording listItem">
                <img
                  src={RecordScreenIcon}
                  className="listItemImg"
                  style={{ marginRight: 16 }}
                />
                <div className="text">
                  Recording is required and cannot be stopped at any point
                  during the Challenge. If the recording is paused more than once, it will result in automatic disqualification from the test.
                </div>
              </div>

              <div className="useAccVideoRecording listItem">
                <img
                  src={CompassIcon}
                  className="listItemImg"
                  style={{ marginRight: 16 }}
                />
                <div className="text">
                  These recordings are subject to Turing's review at any point.
                </div>
              </div>

              <div className="useAccVideoRecording listItem">
                <img
                  src={ReportIcon}
                  className="listItemImg"
                  style={{ marginRight: 16 }}
                />
                <div className="text">
                  <b>
                    Any form of cheating will lead to temporary or permanent account
                    deactivation.
                  </b>
                </div>
              </div>
            </div>
          </div>

          <div className="actionContainer useAccVideoRecording">
            <span className="timeEstimate" style={{ height: 48, marginTop: 16 }}>
              <ClockIcon /> &nbsp;{' '}
              <span>Max. Time {challengeDuration} min </span>
            </span>
            <Button
              type="primary"
              className="button"
              onClick={() => {
                changePreviousDevData(
                  home.extraPassedInfo && home.extraPassedInfo.passedApt,
                  'passedApt'
                );
                onStart();
              }}
            >
              Accept and Start Challenge
            </Button>
          </div>
      </div>
    </Modal>
  );
};

const mapStateToProps = (state) => ({ home: state.home });

export default connect(mapStateToProps, null)(APTWarning);
